import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { LoadingButton } from 'ui/buttons/LoadingButton';
import { Row } from 'ui/Flex';
import { CampaignDefineView } from '../CampaignDefineView';
import { CampaignSettingsView } from '../CampaignSettingsView';
import { CampaignItem } from '../models/CampaignItem';
import { CampaignDefineFormData } from './CreateCampaignDefine';

interface CreateCampaignReviewProps {
    defineData: CampaignDefineFormData;
    settingsData: CampaignItem[];
    isLoading?: boolean;
    onContinue: () => void;
    onBack: () => void;
    onEdit: () => void;
    onSettingsEdit: () => void;
}

export const CreateCampaignReview: React.FC<CreateCampaignReviewProps> = ({
    defineData,
    isLoading,
    onContinue,
    onBack,
    onEdit,
    settingsData,
    onSettingsEdit
}) => (
    <Box padding={3} maxWidth={600}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h4" color="secondary">
                    3. Review
                </Typography>
                <Typography variant="body2">
                    Here you can review what was created on previous steps
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <CampaignDefineView defineData={defineData} onEdit={onEdit} />
            </Grid>
            <Grid item xs={12}>
                <CampaignSettingsView settingsData={settingsData} onEdit={onSettingsEdit} />
            </Grid>
            <Grid item xs={12}>
                <Row flex={1} align="space-between">
                    <Button variant="outlined" color="primary" onClick={onBack}>
                        Back to Configure
                    </Button>
                    <LoadingButton
                        disabled={isLoading}
                        loading={isLoading}
                        onClick={onContinue}
                        color="primary"
                        variant="contained"
                    >
                        Go to Campaigns
                    </LoadingButton>
                </Row>
            </Grid>
        </Grid>
    </Box>
);
